import PropTypes from 'prop-types';

export const IconEye = ({ isHidden }) => {
    return (
        <i className={`me-1 mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px text-dark`} />
    )
}
IconEye.propTypes = {
    isHidden: PropTypes.bool
}